import { render, staticRenderFns } from "./HotelServices.vue?vue&type=template&id=28faf05e&"
import script from "./HotelServices.vue?vue&type=script&lang=js&"
export * from "./HotelServices.vue?vue&type=script&lang=js&"
import style0 from "./HotelServices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports